import { Counter } from "./components/Counter";
import AboutUs from "./components/About";
import Home from "./components/Home";
import Services from "./components/Services";
import Tracking from "./components/Tracking";
import RateandTaxes from "./components/RateandTaxes";
import ContactUs from "./components/Contactus";
import Enquiry from "./components/Enquiry";
import FAQS from "./components/Faqs";
import ClientLogin from "./components/ClientLogin";
import PickupReport from "./components/PickupReport";
import PickupStatusReport from "./components/PickupStatusReport";
import ChangePassword from "./components/ChangePassword";
import CreateContactDetails from "./components/CreateContactDetails";
import PODUpload from "./components/UploadPOD";

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/services',
    element: <Services />
  },
  {
    path: '/about-us',
    element: <AboutUs />
  },
  {
    path: '/tracking',
    element: <Tracking />
  },
  {
    path: '/rate-and-texes',
    element: <RateandTaxes />
  },
  {
    path: '/contact-us',
    element: <ContactUs />
  },
  {
    path: '/enquiry',
    element: <Enquiry />
  },
  {
    path: '/faqs',
    element: <FAQS />
  },
  {
      path: '/ClientLogin',
      element: <ClientLogin />
  },
  {
      path: '/PickupReport',
      element: <PickupReport />
  },
  {
      path: '/PickupStatusReport',
      element: <PickupStatusReport />
  },
  {
      path: '/ChangePassword',
      element: <ChangePassword />
  },
  {
      path: '/CreateContactDetails',
      element: <CreateContactDetails />
  },
  {
      path: '/PODUpload',
      element: <PODUpload />
  },
];

export default AppRoutes;
